import { Switch } from "antd";
import { IThemeColorChangeMod } from "@blings/blings-player";
import { observer } from "mobx-react-lite";
import { useState } from "react";

interface IByLayersSwitch {
  change: IThemeColorChangeMod;
  index: number;
  json: any;
  onLayerChange: (...params) => void;
  onChange: (...params) => void;
}

export const ByLayersSwitch = observer(
  ({ change, json, index, onLayerChange, onChange }: IByLayersSwitch) => {
    const [isLayer, setIsLayer] = useState(
      "isLayers" in change && change.isLayers
    );
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Switch
          defaultChecked
          size="default"
          checked={"isLayers" in change && change.isLayers}
          onChange={(v) => {
            onChange(index, "isLayers", v);
            setIsLayer(v);
          }}
        />
        <span style={{ marginLeft: "14px" }}>
          {isLayer ? "Layers" : "Global"}
        </span>
      </div>
    );
  }
);
